import styled from '@emotion/styled';

export const SectionHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e2e8f0;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .section-icon {
      font-size: 1.25rem;
    }

    .section-count {
      font-size: 1rem;
      font-weight: 600;
      color: #64748b;
      background-color: #f1f5f9;
      padding: 0.25rem 0.75rem;
      border-radius: 9999px;
    }
  }

  &.unread {
    border-bottom-color: #fef3c7;

    h3 {
      color: #92400e;

      .section-count {
        background-color: #fef3c7;
        color: #92400e;
      }
    }
  }

  &.read {
    border-bottom-color: #d1fae5;

    h3 {
      color: #065f46;

      .section-count {
        background-color: #d1fae5;
        color: #065f46;
      }
    }
  }
`;
